module.exports = __webpack_public_path__ + "img/quest_icon_0070_special3.a776d901.png";